module.exports = __webpack_public_path__ + "static/cabin/Cabin-Bold.eot";